import { ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/site/Reveal";
import { INDUSTRIES } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export default function Industries() {
  return (
    <section id="industries" className="bg-ivory text-slateink">
      <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <Chapter n="Chapter 07" label="Industries & Formats" />
        <div className="flex flex-wrap items-end justify-between gap-8">
          <Reveal>
            <h2 className="max-w-2xl text-balance font-serif text-3xl font-medium leading-tight tracking-tight sm:text-4xl lg:text-5xl">
              Built for the formats that move the industry.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-sm leading-relaxed text-bodylight sm:text-base">
              Each format carries its own financial rhythm. Our controls are tuned to the cadence of
              the production, not the other way around.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.id} delay={0.1 * i}>
              <button
                data-testid={`industry-card-${ind.id}`}
                onClick={() => scrollToId("#contact")}
                className="group block w-full text-left"
              >
                <div className="spotlight-frame relative overflow-hidden border border-slateink/15">
                  <img
                    src={ind.img}
                    alt={ind.title}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover sepia-[0.3] contrast-[1.03] brightness-[0.97] saturate-[0.8] transition-all duration-700 ease-out group-hover:scale-105 group-hover:sepia-0 group-hover:saturate-100"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-6">
                    <div className="flex items-center justify-between">
                      <h3 className="font-serif text-xl font-medium text-ivory">{ind.title}</h3>
                      <ArrowUpRight size={16} className="text-gold opacity-0 transition-all duration-300 group-hover:opacity-100" />
                    </div>
                    <span className="mt-3 block h-px w-8 bg-inkred transition-all duration-500 group-hover:w-full" aria-hidden="true" />
                  </div>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-bodylight">{ind.body}</p>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
